import {ErrorBoundary} from '@sentry/react';
import * as LE from '@wandb/weave/components/PagePanelComponents/Home/LayoutElements';
import {dummyProps} from '@wandb/weave/components/Panel2/panel';
import {PanelInteractContextProvider} from '@wandb/weave/components/Panel2/PanelInteractContext';
import {
  PanelPanel,
  PanelRootContextProvider,
} from '@wandb/weave/components/Panel2/PanelPanel';
import {PanelRenderedConfigContextProvider} from '@wandb/weave/components/Panel2/PanelRenderedConfigContext';
import {useWeaveContext} from '@wandb/weave/context';
import {NotebookComputeGraphContextProvider} from '@wandb/weave/contextProviders';
import {constString, opGet} from '@wandb/weave/core';
import React, {useEffect, useMemo} from 'react';
import {StateInspector} from 'reinspect';

import * as S from './Dashboard.styles';

type ObservabilityDashboardProps = {
  boardURI: string;
};

export const ObservabilityDashboard = ({
  boardURI,
}: ObservabilityDashboardProps) => {
  const weave = useWeaveContext();
  useEffect(() => {
    weave.client.setPolling(true);
  }, [weave]);

  const pagePanelInput = useMemo(() => {
    if (!boardURI) {
      return null;
    }
    return opGet({uri: constString(boardURI)});
  }, [boardURI]);

  const BoundPagePanel = useMemo(() => {
    return (
      <PanelPanel
        key={boardURI}
        input={pagePanelInput as any}
        {...dummyProps}
      />
    );
  }, [pagePanelInput, boardURI]);

  return (
    <S.Container>
      <LE.VStack
        style={{
          backgroundColor: 'white',
        }}>
        <LE.HStack>
          <LE.VStack>
            <div
              className="weave-root"
              style={{
                width: '100%',
                height: '100%',
                overflowY: 'auto',
              }}>
              <React.Suspense fallback="loading">
                <ErrorBoundary>
                  <StateInspector name="WeaveApp">
                    <NotebookComputeGraphContextProvider>
                      <PanelRootContextProvider>
                        <PanelInteractContextProvider>
                          <PanelRenderedConfigContextProvider>
                            {BoundPagePanel}
                          </PanelRenderedConfigContextProvider>
                        </PanelInteractContextProvider>
                      </PanelRootContextProvider>
                    </NotebookComputeGraphContextProvider>
                  </StateInspector>
                </ErrorBoundary>
              </React.Suspense>
            </div>
          </LE.VStack>
        </LE.HStack>
      </LE.VStack>
    </S.Container>
  );
};
